import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Fade } from '@mui/material';

interface PageTransitionProps {
  children: ReactNode;
}

const PageTransition: React.FC<PageTransitionProps> = ({ children }) => {
  const location = useLocation();

  return (
    <Fade in={true} timeout={400} key={location.pathname}>
      <Box
        sx={{
          width: '100%',
          minWidth: 0,
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {children}
      </Box>
    </Fade>
  );
};

export default PageTransition;
